import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { EmailTemplate } from 'utils/types';

import c from '../utils/constants';

export default function useGetEmailTemplate(id: string) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<EmailTemplate, Error>({
    queryKey: [c.TEMPLATES, id],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/channels/email/templates/${id}`,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/email/templates/${id}`,
          },
        }),
      );

      return data;
    },
    enabled: !!id,
  });
}
